export default __webpack_public_path__ + "static/gallery8-745ac22077ece49fdcf2b4e6677351a4.png";